module.exports = __webpack_public_path__ + "static/banner-2795492443d8003d5594eb3339c79d06.png";